<template>

<ticket></ticket>

</template>

<script>
import ticket from './MTicket.vue';


export default {
    components: {
        ticket,
    }
}

</script>